import { REGIONS, ENVS, Colors } from '@adsk/bim360-matrix-react-helpers/es/consts';

export const RFI_ENV_CONFIG_KEYS = {
  RFI_BE: 'RFI_BE',
  PJM_FE: 'PJM_FE'
};

const US_CONFIG = {
  [ENVS.DEV]: {
    [RFI_ENV_CONFIG_KEYS.RFI_BE]: 'https://developer-stg.api.autodesk.com/bim360/rfis-dev',
    [RFI_ENV_CONFIG_KEYS.PJM_FE]: 'https://pm.b360-dev.autodesk.com'
  },
  [ENVS.QA]: {
    [RFI_ENV_CONFIG_KEYS.RFI_BE]: 'https://developer-stg.api.autodesk.com/bim360/rfis-qa',
    [RFI_ENV_CONFIG_KEYS.PJM_FE]: 'https://pm.b360-qa.autodesk.com'
  },
  [ENVS.STAGING]: {
    [RFI_ENV_CONFIG_KEYS.RFI_BE]: 'https://developer-stg.api.autodesk.com/bim360/rfis-stg',
    [RFI_ENV_CONFIG_KEYS.PJM_FE]: 'https://pm.b360-staging.autodesk.com'
  },
  [ENVS.PROD]: {
    [RFI_ENV_CONFIG_KEYS.RFI_BE]: 'https://developer.api.autodesk.com/bim360/rfis',
    [RFI_ENV_CONFIG_KEYS.PJM_FE]: 'https://pm.b360.autodesk.com'
  }
};

export const ENV_CONFIGS = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: {
    [ENVS.DEV]: US_CONFIG[ENVS.DEV],
    [ENVS.QA]: US_CONFIG[ENVS.QA],
    [ENVS.STAGING]: {
      [RFI_ENV_CONFIG_KEYS.RFI_BE]: US_CONFIG[ENVS.STAGING][RFI_ENV_CONFIG_KEYS.RFI_BE],
      [RFI_ENV_CONFIG_KEYS.PJM_FE]: 'https://pm.b360-staging.eu.autodesk.com'
    },
    [ENVS.PROD]: {
      [RFI_ENV_CONFIG_KEYS.RFI_BE]: US_CONFIG[ENVS.PROD][RFI_ENV_CONFIG_KEYS.RFI_BE],
      [RFI_ENV_CONFIG_KEYS.PJM_FE]: 'https://pm.b360.eu.autodesk.com'
    }
  }
};

export const Statuses = {
  DRAFT: 'draft',
  OPEN: 'open',
  SUBMITTED: 'submitted',
  ANSWERED: 'answered',
  REJECTED: 'rejected',
  CLOSED: 'closed',
  VOID: 'void'
};

export const statusColorMapping = {
  [Statuses.DRAFT]: Colors.GRAY_DARK,
  [Statuses.SUBMITTED]: Colors.PURPLE,
  [Statuses.OPEN]: Colors.YELLOW,
  [Statuses.ANSWERED]: Colors.BLUE,
  [Statuses.REJECTED]: Colors.RED,
  [Statuses.CLOSED]: Colors.GRAY,
  [Statuses.VOID]: Colors.GRAY
};

export const RFI_ENV_TYPES = {
  QA: 'QA',
  STAGING: 'Staging',
  PROD: 'PROD'
};
